module.exports = __webpack_public_path__ + "img/tools-white.7ab0752e.svg";